import { Col, Container, getTypographyDefaultColor, RatingStars, Row, Typography } from '@ag1/ui';
import clsx from 'clsx';
import { HeroAnimated as HeroAnimatedProps } from 'types/studio/studio';
import CustomPortableText from 'shared/studio/PortableText/PortableText';
import { getThemeCSSClass } from 'shared/utils/getThemeCSSClass';
import styles from './Reviews.module.scss';
import { useReviewsSlider } from '../hooks/useReviewsSlider';

type Props = Pick<HeroAnimatedProps, 'ratingValue' | 'ratingTitle' | 'reviews' | 'theme'>;

const Reviews = ({ ratingTitle, ratingValue, reviews, theme }: Props) => {
  const slider = useReviewsSlider({
    itemsLength: reviews?.length
  });

  return (
    <div className={styles.root}>
      <Container narrow>
        <Row>
          <Col span={{ xxs: 12, m: 4, l: 3 }}>
            {ratingValue && ratingTitle && (
              <div className={styles.ratingBlock}>
                <RatingStars
                  rating={ratingValue}
                  thin
                  className={styles.ratingStars}
                  inheritFontSize
                />
                <Typography
                  component="div"
                  variant="portalCaption"
                  size="2"
                  noPadding
                  color={getTypographyDefaultColor(theme)}
                  className={clsx(styles.ratingTitle, getThemeCSSClass(theme))}
                  weight="400">
                  <CustomPortableText value={ratingTitle} />
                </Typography>
              </div>
            )}
          </Col>
          <Col span={{ xxs: 12, m: 8, l: 6 }} offset={{ l: 1 }}>
            <div ref={slider.ref} className={styles.reviewsViewport}>
              <div className={styles.reviewsContainer}>
                {reviews?.map((item) => {
                  const { _key: reviewKey } = item;
                  return (
                    <div key={reviewKey} className={styles.reviewSlide}>
                      <Typography
                        component="div"
                        variant="portalText"
                        size="2"
                        noPadding
                        color={getTypographyDefaultColor(theme)}
                        className={clsx(styles.reviewText, getThemeCSSClass(theme))}
                        weight="400">
                        {item.reviewText}
                      </Typography>
                      <Typography
                        component="div"
                        variant="caption"
                        size="1"
                        noPadding
                        color={getTypographyDefaultColor(theme)}
                        className={clsx(styles.reviewData, getThemeCSSClass(theme))}
                        weight="400">
                        {item.reviewData}
                      </Typography>
                    </div>
                  );
                })}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
export default Reviews;
